<template>
  <v-container
    id="templateSectionSummary"
    class="oe-summary-subsection mt-6 pa-0"
  >
    <div class="text-center display-1">
      {{ section.templateSection }}
    </div>
    <div
      v-if="section.answerMulti"
    >
      <div
        v-for="(answerGroup,answerGroupKey) in section.answerGroups"
        :key="answerGroupKey"
        class="multi-section-summary"
      >
        <template-answer-summary
          :answers="answerGroup.answers"
        />
      </div>
    </div>
    <template-answer-summary
      v-if="!section.answerMulti"
      :answers="section.answers"
    />
  </v-container>
</template>

<script>
  export default {
    name: 'TemplateSectionSummary',

    components: {
      TemplateAnswerSummary: () => import('./TemplateAnswerSummary'),
    },

    props: {
      section: {
        type: Object,
        default: null,
      },
    },
  }
</script>

<style lang="sass">
  .multi-section-summary
    border-width: 3px
    border-style: solid
    border-color: rgba(0, 255, 0, 0.3) !important
    border-radius: 10px !important
    background-color: rgba(0, 255, 0, 0.02) !important
    padding-left: 10px !important
    padding-right: 10px !important
    margin-bottom: 10px !important
</style>
